"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _knocked = require("./knocked");
Object.keys(_knocked).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _knocked[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _knocked[key];
    }
  });
});
var _sourceCreated = require("./sourceCreated");
Object.keys(_sourceCreated).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _sourceCreated[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _sourceCreated[key];
    }
  });
});
var _knockAnswered = require("./knockAnswered");
Object.keys(_knockAnswered).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _knockAnswered[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _knockAnswered[key];
    }
  });
});
var _sourceToggled = require("./sourceToggled");
Object.keys(_sourceToggled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _sourceToggled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _sourceToggled[key];
    }
  });
});
var _presenterFeatured = require("./presenterFeatured");
Object.keys(_presenterFeatured).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _presenterFeatured[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _presenterFeatured[key];
    }
  });
});
var _broadcastSyncedServerTime = require("./broadcastSyncedServerTime");
Object.keys(_broadcastSyncedServerTime).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _broadcastSyncedServerTime[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _broadcastSyncedServerTime[key];
    }
  });
});
var _attendeeRosterChanged = require("./attendeeRosterChanged");
Object.keys(_attendeeRosterChanged).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _attendeeRosterChanged[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _attendeeRosterChanged[key];
    }
  });
});
var _attendeeMicStatusChanged = require("./attendeeMicStatusChanged");
Object.keys(_attendeeMicStatusChanged).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _attendeeMicStatusChanged[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _attendeeMicStatusChanged[key];
    }
  });
});
var _sceneLayoutChanged = require("./sceneLayoutChanged");
Object.keys(_sceneLayoutChanged).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _sceneLayoutChanged[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _sceneLayoutChanged[key];
    }
  });
});
var _muteChanged = require("./muteChanged");
Object.keys(_muteChanged).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _muteChanged[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _muteChanged[key];
    }
  });
});
var _sceneLayersUpdated = require("./sceneLayersUpdated");
Object.keys(_sceneLayersUpdated).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _sceneLayersUpdated[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _sceneLayersUpdated[key];
    }
  });
});
var _toggledPresenterLive = require("./toggledPresenterLive");
Object.keys(_toggledPresenterLive).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _toggledPresenterLive[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _toggledPresenterLive[key];
    }
  });
});
var _backgroundAdded = require("./backgroundAdded");
Object.keys(_backgroundAdded).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _backgroundAdded[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _backgroundAdded[key];
    }
  });
});
var _backgroundLiveToggled = require("./backgroundLiveToggled");
Object.keys(_backgroundLiveToggled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _backgroundLiveToggled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _backgroundLiveToggled[key];
    }
  });
});
var _directorRequested = require("./directorRequested");
Object.keys(_directorRequested).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _directorRequested[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _directorRequested[key];
    }
  });
});
var _directorRequestAnswered = require("./directorRequestAnswered");
Object.keys(_directorRequestAnswered).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _directorRequestAnswered[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _directorRequestAnswered[key];
    }
  });
});
var _bannerLiveToggled = require("./bannerLiveToggled");
Object.keys(_bannerLiveToggled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _bannerLiveToggled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _bannerLiveToggled[key];
    }
  });
});
var _mixerAttendeeJoined = require("./mixerAttendeeJoined");
Object.keys(_mixerAttendeeJoined).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _mixerAttendeeJoined[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _mixerAttendeeJoined[key];
    }
  });
});
var _sourceOrderChanged = require("./sourceOrderChanged");
Object.keys(_sourceOrderChanged).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _sourceOrderChanged[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _sourceOrderChanged[key];
    }
  });
});
var _attendeeCameraStatusChanged = require("./attendeeCameraStatusChanged");
Object.keys(_attendeeCameraStatusChanged).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _attendeeCameraStatusChanged[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _attendeeCameraStatusChanged[key];
    }
  });
});
var _attendeeCameraRemoved = require("./attendeeCameraRemoved");
Object.keys(_attendeeCameraRemoved).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _attendeeCameraRemoved[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _attendeeCameraRemoved[key];
    }
  });
});
var _cancelPresenterKnock = require("./cancelPresenterKnock");
Object.keys(_cancelPresenterKnock).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _cancelPresenterKnock[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _cancelPresenterKnock[key];
    }
  });
});
var _multipleAttendeeCameraStatusChanged = require("./multipleAttendeeCameraStatusChanged");
Object.keys(_multipleAttendeeCameraStatusChanged).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _multipleAttendeeCameraStatusChanged[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _multipleAttendeeCameraStatusChanged[key];
    }
  });
});
var _screenShareStopped = require("./screenShareStopped");
Object.keys(_screenShareStopped).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _screenShareStopped[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _screenShareStopped[key];
    }
  });
});
var _sourceDeleted = require("./sourceDeleted");
Object.keys(_sourceDeleted).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _sourceDeleted[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _sourceDeleted[key];
    }
  });
});
var _multipleMuteChanged = require("./multipleMuteChanged");
Object.keys(_multipleMuteChanged).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _multipleMuteChanged[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _multipleMuteChanged[key];
    }
  });
});
var _streamToggled = require("./streamToggled");
Object.keys(_streamToggled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _streamToggled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _streamToggled[key];
    }
  });
});
var _syncedBrandingSettings = require("./syncedBrandingSettings");
Object.keys(_syncedBrandingSettings).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _syncedBrandingSettings[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _syncedBrandingSettings[key];
    }
  });
});
var _dailyMuteChanged = require("./dailyMuteChanged");
Object.keys(_dailyMuteChanged).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _dailyMuteChanged[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _dailyMuteChanged[key];
    }
  });
});
var _agoraScreenShareStopped = require("./agoraScreenShareStopped");
Object.keys(_agoraScreenShareStopped).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _agoraScreenShareStopped[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _agoraScreenShareStopped[key];
    }
  });
});
var _agoraAttendeeMuteUnmuteChanged = require("./agoraAttendeeMuteUnmuteChanged");
Object.keys(_agoraAttendeeMuteUnmuteChanged).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _agoraAttendeeMuteUnmuteChanged[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _agoraAttendeeMuteUnmuteChanged[key];
    }
  });
});
var _agoraCameraStatusChanged = require("./agoraCameraStatusChanged");
Object.keys(_agoraCameraStatusChanged).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _agoraCameraStatusChanged[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _agoraCameraStatusChanged[key];
    }
  });
});
var _dailyCameraStatusChanged = require("./dailyCameraStatusChanged");
Object.keys(_dailyCameraStatusChanged).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _dailyCameraStatusChanged[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _dailyCameraStatusChanged[key];
    }
  });
});